import { type JSX, ReactNode, useContext, useMemo } from "react";

import {
  AttributeValueContentType,
  type ValueContentImageProps,
} from "@plansoft-configuration-renderer/components";
import { ValueComponentContext } from "@plansoft-configuration-renderer/layout";

export function ImageInfoOverride(props: { children: ReactNode }): JSX.Element {
  const existing = useContext(ValueComponentContext);
  const imageKey = AttributeValueContentType.Image;
  const OriginalImage = existing[imageKey];

  const NoInfoImage = useMemo(
    () =>
      function NoInfoThumbnailImage(
        imageProps: ValueContentImageProps,
      ): JSX.Element {
        return <OriginalImage {...imageProps} showInfo={false} />;
      },
    [OriginalImage],
  );

  const merged = useMemo(
    () => ({ ...existing, [imageKey]: NoInfoImage }),
    [existing, imageKey, NoInfoImage],
  );

  return (
    <ValueComponentContext.Provider value={merged}>
      {props.children}
    </ValueComponentContext.Provider>
  );
}
